import { TRIGGER_FETCH_REPAYMENT_HISTORY_API, TRIGGER_FETCH_REPAYMENT_HISTORY_API_SUCCESS, CLEAR_REPAYMENT_HISTORY } from 'redux/actionTypes';

export function triggerFetchRepaymentHistoryApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_REPAYMENT_HISTORY_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchRepaymentHistoryApiCallSuccess(data, repaymentHistory) {
	return {
		type: TRIGGER_FETCH_REPAYMENT_HISTORY_API_SUCCESS,
		data,
		repaymentHistory
	};
}

export function clearRepaymentHistory(data) {
	return {
		type: CLEAR_REPAYMENT_HISTORY,
		data,
	};
}
